import { BREAKOUT_DISPLAY, normalizeBreakout } from './parseMetrics';
import type { MetricRow, RawRow } from '../types';
import { POPULARITY_METADATA_BY_KEY } from 'utils/metrics';

/** A `*_METADATA_BY_KEY` map from utils/metrics (popularity, tiktok, …). */
type MetadataByKey = Record<
    string,
    {
        tableHeadColumnLabel?: string;
        notation?: string;
        format?: (v: number) => string;
    }
>;

export const columnLabel = (
    key: string,
    metaByKey: MetadataByKey = POPULARITY_METADATA_BY_KEY,
): string => metaByKey[key]?.tableHeadColumnLabel ?? key;

export const formatColumnValue = (
    key: string,
    formattedRow?: MetricRow,
    rawRow?: RawRow,
    metaByKey: MetadataByKey = POPULARITY_METADATA_BY_KEY,
): string | null => {
    const fromFormatted = formattedRow?.[columnLabel(key, metaByKey)]?.value;
    if (fromFormatted !== undefined && fromFormatted !== null) {
        return normalizeBreakout(fromFormatted) ?? null;
    }
    const raw = rawRow?.[key] as number | undefined | null;
    if (raw === undefined || raw === null) return null;
    const meta = metaByKey[key];
    const formatted = meta?.format ? meta.format(raw) : String(raw);
    // The shared growth/percentage formatters (formatGrowth/formatPercentage)
    // return a <Breakout/> React element — not a string — for >1000% values.
    // The inline table needs a plain string (it renders text and derives tone via
    // String.startsWith), so coerce that case to the breakout label.
    return typeof formatted === 'string' ? formatted : BREAKOUT_DISPLAY;
};
